import { createSlice } from '@reduxjs/toolkit';
import { IUtility } from '../../types/UtilityDetails';
import { fetchUtilityDetailsAsync, fetchUtilityDetailsAsyncBuilder } from './asyncRequests/fetchUtilityDetailsAsync';
import { IWellWaterSystemWCoordinates } from '../../types/WellWaterSystemCoordinates';

export interface UtilityDetailsInitialState {
  data: IUtility
  wellData: IWellWaterSystemWCoordinates
  loading: boolean;
  error: string;
  success: boolean;
  showDrawer: boolean;
}

const initialState: UtilityDetailsInitialState = {
  data: {} as IUtility,
  wellData: {} as IWellWaterSystemWCoordinates,
  loading: false,
  error: '',
  success: false,
  showDrawer: false,
};

export const utilityDetailSlice = createSlice({
  name: 'utilityDetailSlice',
  initialState,
  reducers: {
    resetUtility:(state)=>{
      state.data = initialState.data
    },
    toggleDrawer: (state) => {
      state.showDrawer = !state.showDrawer;
    },
    closeDrawer: (state) => {
      state.showDrawer = false;
    },
    openDrawer: (state) => {
      state.showDrawer = true;
    },
    setSelectedWellData:(state,action)=> {
      state.wellData = action.payload
    },
  },
  extraReducers: (builder) => {
    fetchUtilityDetailsAsyncBuilder(builder);
  },
});

export const UtilityDetailActions = {
  ...utilityDetailSlice.actions,
  fetchUtilityDetailsAsync,
};

export const UtilityDetailReducer = utilityDetailSlice.reducer;